import React from 'react';

interface TwoLineCellProps {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  primaryClassName?: string;
  secondaryClassName?: string;
}

export const TwoLineCell: React.FC<TwoLineCellProps> = ({
  primary,
  secondary,
  primaryClassName,
  secondaryClassName,
}) => (
  <div className="flex flex-col">
    <span className={primaryClassName ?? 'font-medium'}>
      {primary}
    </span>
    {secondary != null && secondary !== '' && (
      <span className={secondaryClassName ?? 'text-caption text-tertiary mt-0.5'}>
        {secondary}
      </span>
    )}
  </div>
);

TwoLineCell.displayName = 'TwoLineCell';
